import React from "react";
import { Box } from "@mui/material";
import styles from "./textLabelComponent.module.scss";
import i18next from "i18next";
import PropTypes from "prop-types";

const TextLabel = (props) => {
  const {
    label,
    value,
    hasLink = false,
    hasStrike = false,
    hasSubValue = false,
    subValue,
  } = props;
  const addColor = () => {
    if (hasLink) return styles.inputWrappercolor;
    else if (hasStrike) return styles.inputStrike;
    else return styles.inputWrapper;
  };
  return (
    <Box data-testid="TextLabel">
      <Box className={styles.detailWrapper}>
        <Box className={styles.labelWrapper}>{i18next.t(label)}</Box>
        <Box className={addColor()}>{value}</Box>
        {hasSubValue && <Box className={styles.inputWrapper}>{subValue}</Box>}
      </Box>
    </Box>
  );
};

export default TextLabel;
TextLabel.propTypes = {
  label: PropTypes.any,
  value: PropTypes.any,
  hasLink: PropTypes.any,
  hasStrike: PropTypes.any,
  hasSubValue: PropTypes.any,
  subValue: PropTypes.any,
};
